<template>
  <div class="videoPage">
    <div class="videoBox">
      <LivePlayer
        :videoUrl="vUrl"
        autoplay
        live
        stretch
        class="mb10 mySelfVideo"
      ></LivePlayer>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/

import LivePlayer from "@liveqing/liveplayer";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "monitorVideo",
  components: { LivePlayer },
  data() {
    return {
    deviceCode:'',
      vUrl: "",
      clientType: getDeviceType(),
    };
  },

  mounted() {
    document.title = '视频';
    this.deviceCode = this.$route.query.commonId;
    this.getVideoUrl();
  },
  methods: {
    getVideoUrl() {
      //ios回调m3u8  安卓回调webRtc
      let _this = this;
      _this.$api.universal
        .monitordeviceMsg({
          device: this.deviceCode,
          type: _this.clientType == "android" ? "webRtc" : "m3u8",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            if (res.data) {
              _this.vUrl = res.data.videoUrl;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
};
</script>
<style lang="less">
.videoPage {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #f6f6f6;
  .videoBox {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding-top: 40%;
    .mySelfVideo {
      width: 100%;
      height: 40%;
      position: relative;
      .video-wrapper {
        height: 100%;
        padding-bottom: 10% !important;
      }
      .vjs-big-play-button {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
}
</style>